import React, { useEffect } from 'react';

function clearOldOIDCStorage() {
  const oidcKeys = Object.keys(localStorage).filter((key) => key.startsWith('oidc.'));

  if (oidcKeys.length > 0) {
    // Armazena os itens OIDC com seus timestamps
    const itemsWithTimestamps = oidcKeys.map((key) => ({
      key,
      item: JSON.parse(localStorage.getItem(key)),
    })).filter(({ item }) => item); // Filtra itens que podem ser analisados

    // Ordena os itens pelo timestamp 'created' em ordem decrescente
    itemsWithTimestamps.sort((a, b) => b.item.created - a.item.created);

    // Mantém apenas as 5 entradas mais recentes
    const keysToPreserve = itemsWithTimestamps.slice(0, 5).map(({ key }) => key);

    // Atraso de 10 segundos para limpeza
    setTimeout(() => {
      oidcKeys.forEach((key) => {
        if (!keysToPreserve.includes(key)) {
          console.log(`Removing key: ${key}`);
          localStorage.removeItem(key);
        }
      });

      console.log(`Preserved the latest 5 OIDC entries: ${keysToPreserve.join(', ')}`);
    }, 1500);
  }
}

export function useStorageMonitor() {
  useEffect(() => {
    clearOldOIDCStorage();
  }, []);
}
